import assign from 'lodash/assign'
import * as api from 'common/api'
import * as Department from './department'
import * as Teacher from './teacher'

// 创建、编辑文件
export let edit = data => {
  data = assign({}, data)
  if (!data.public) delete data.public
  return api.postFile('s3/department/edit', data)
}

// 列出部门下文件
export let list = params => api.get('s3/department/list', params)

// 列出全校共享文件
export let public_list = () => api.get('s3/department/public')

// 查看文件
export let get = params => api.get('s3/department/edit', params)

// 删除文件
export let remove = params => api.post('s3/department/delete', params)

export let user_department_list = async params => {
  let [departments, user] = await Promise.all([
    Department.list(),
    Teacher.get(params),
  ])
  return departments.filter(department => {
    return user.departments.includes(department.uid) && department.funcs.includes('department_file')
  })
}



// WEBPACK FOOTER //
// ./src/api/storage.js